type Environment = "local" | "develop" | "live";

interface BackendEndpoints {
    chat: string;
    voice: string;
    auth: string;
}

/*                                   */

export const CHAT_MESSAGES_LOCAL_STORAGE_KEY = "nucleus_chatbot_history";
export const FLOATING_BUTTON_LOCAL_STORAGE_KEY = "nucleus_chatbot_tooltip_closed";
export const FLOATING_BUTTON_DESCRIPTION_DELAY = 3000; /* */

/*                 */

/**
 *
 *
 */
export const CHAT_CHARACTER_LIMIT = 2000;

/*   */

/**
 *
 *
 */
export const LOGIN_URL = import.meta.env.VITE_LOGIN_URL || "/customer-identity/login";

/**
 *
 */
const DEFAULT_BACKEND_ENDPOINTS: Record<Environment, BackendEndpoints> = {
    local: {
        chat: "ws:/*                           */
        voice: "ws:/*                                 */
        auth: "http:/*                                */
    },
    develop: {
        chat: "wss:/*                                */
        voice: "wss:/*                                      */
        auth: "/conversation/auth",
    },
    live: {
        chat: "wss:/*                                              */
        voice: "wss:/*                                                    */
        auth: "/conversation/auth",
    },
};

export const BACKEND_ENDPOINTS = getBackendEndpoints();
export const IS_LOCAL = detectEnvironment() === "local";

/**
 *
 */
function getBackendEndpoints(): BackendEndpoints {
    const env = detectEnvironment();

    return {
        chat: import.meta.env.VITE_BACKEND_URL || DEFAULT_BACKEND_ENDPOINTS[env].chat,
        voice: import.meta.env.VITE_VOICE_URL || DEFAULT_BACKEND_ENDPOINTS[env].voice,
        auth: import.meta.env.VITE_AUTH_URL || DEFAULT_BACKEND_ENDPOINTS[env].auth,
    };
}

/**
 *
 */
function detectEnvironment(): Environment {
    const hostname = location.hostname;

    if (hostname === "www.otto.de") return "live";
    if (hostname === "develop.otto.de") return "develop";
    if (hostname.includes("localhost")) return "local";

    console.warn(`Unknown environment: ${hostname}. Defaulting to 'develop'.`);
    return "develop";
}
